import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaEnvelope, FaSun, FaMoon, FaDiscord, FaFilePdf, FaImages, FaYoutube } from 'react-icons/fa6';

export default function Portfolio() {
  const [darkMode, setDarkMode] = useState(true);

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div style={{
      backgroundColor: darkMode ? '#000' : '#fff',
      color: darkMode ? '#fff' : '#000',
      fontFamily: 'Poppins, sans-serif',
      transition: 'background-color 0.3s, color 0.3s'
    }}>
      <header style={{
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: darkMode ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(6px)',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
      }}>
        <div></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <a href="mailto:underscoremarcus@gmail.com" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaEnvelope /></a>
          <a href="https://github.com/mrcsm" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaGithub /></a>
          <a href="https://discord.com/users/274734101821390856" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '1.25rem' }}><FaDiscord /></a>
          <button onClick={toggleTheme} style={{ padding: '0.5rem', background: '#fb923c', borderRadius: '0.75rem', color: '#fff', border: 'none', fontSize: '1.25rem', cursor: 'pointer' }}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </header>

      <main style={{ padding: '2rem 1.5rem', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Hero Section */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            textAlign: 'center',
            paddingTop: '13rem',
            minHeight: '70vh'
          }}
        >
          <img
            src="/profile.jpg"
            alt="Profile"
            style={{
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginBottom: '1rem',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)'
            }}
          />
          <h2 style={{ fontSize: '3rem', fontWeight: '800', color: '#fb923c', margin: 0 }}>
            Marcus M.
          </h2>
          <p style={{ margin: '4px 0 0 0', fontSize: '1.25rem' }}>
            Minecraft Portfolio
          </p>
        </motion.section>

        {/* Experience Section */}
        <motion.section id="experience" initial={{ y: 100, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8 }} style={{ marginBottom: '6rem' }}>
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '2rem' }}>Experience</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/hoplite.jpg"
                alt="Hoplite Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Minecraft Plugin Developer @ Hoplite
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  September 2025 - Present
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Assisting in plugin development for several minigames on the network.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Working remotely with a team of developers on minigames played by over 1 million unique players.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Utilizing Git/GitLab for version control, Notion for task management, and Slack for team communication.
                </p>
              </div>
            </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/hoplite.jpg"
                alt="Hoplite Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Volunteer Quality Assurance Game Tester @ Hoplite
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  March 2025 - September 2025
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Identifying, reproducing, and reporting bugs encountered while testing the network's minigames on ClickUp/Notion
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Providing feedback on gameplay, mechanics, and overall user experience
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Handling bug reports and technical support tickets submitted by players through the network's Discord server
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/arctic.jpg"
                alt="Arctic Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  Minecraft Plugin Developer @ ArcticMC
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  May 2023 - Present
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Assisting in Java development for several minigames on a Minecraft network
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Contributing to feature addition, bug fixing, and code debugging to the network.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Working with lead developer to adapt the codebase for internationalization (I18n)
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Developed ticket and logging systems for the network's Discord bot utilizing Discord4J and gRPC
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Utilizing Git, GitHub, and Discord for developer collaboration, communication, and issue tracking
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
              <img
                src="/uhc.png"
                alt="UHC Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'scale-down',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginTop: '-19px'
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: '0 0 4px 0' }}>
                  UHC Server Developer @ Other UHC Servers
                </h4>
                <p style={{ fontSize: '0.875rem', color: '#555', margin: '2px 0 8px 0'  }}>
                  2018 - 2023
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Worked on numerous small UHC servers for the r/ultrahardcore Reddit Community.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Majority were developed in Skript until 2019 when I began learning Java and learnt Minecraft Plugin Development.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Developed servers for versions ranging from 1.8 to 1.18.
                </p>
                <p style={{ fontSize: '1rem', margin: '0.5rem 0' }}>
                ● Led most teams during developmental phases, handling the majority of development and design decisions.
                </p>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Projects Section */}
        <motion.section id="projects" initial={{ x: 100, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} transition={{ duration: 0.8 }} style={{ marginBottom: '6rem' }}>
          <h3 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fb923c', marginBottom: '1rem' }}>Projects</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={{ padding: '0.75rem', backgroundColor: '#fed7aa', color: '#000', borderRadius: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', transition: 'transform 0.3s' }}>
              <h4 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', marginTop: '0rem' }}>MCBingo (unreleased)</h4>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>● A personal project for friends to play Minecraft Bingo.</p>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Developed in Java 21 for version 1.21.4, recently entering early playtesting state. Board creation, goal creation, and game mechanics function and the plugin supports Normal, Lockout, and Blackout Bingo game modes.</p>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Utilizes ItemsAdder for custom items and icons.</p>
              <hr></hr>
              <a href="https://imgur.com/a/8zJezVo" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaImages />Album of images from current product</a>
            </div>

            <div style={{ padding: '0.75rem', backgroundColor: '#fed7aa', color: '#000', borderRadius: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', transition: 'transform 0.3s' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                    <img
                    src="/arctic.jpg"
                    alt="Arctic Logo"
                    style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '8px',
                        objectFit: 'scale-down',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    />
                    <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>ArcticMC</h4>
                </div>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>● A Minecraft Server Network specializing in the UHC gamemode developed in Java for versions 1.8 and 1.20.1.</p>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● I implemented features for the UHC gamemode, tested bugs, and fixed those bugs.</p>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Made numerous contributions to the server in the form of Game Modifiers for Hosted Games, assisting in adapting the codebase for internationalization, and designing and developing the ticket and punishment logging systems for the network's Discord bot.</p>
                <hr></hr>
                <a href="https://imgur.com/a/DPsjZmN" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaImages />Album of the Ticket/Punishment logs system</a>
            </div>

            <div style={{ padding: '0.75rem', backgroundColor: '#fed7aa', color: '#000', borderRadius: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', transition: 'transform 0.3s' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                    <img
                    src="/mcroyale.png"
                    alt="MCRoyale Logo"
                    style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '8px',
                        objectFit: 'scale-down',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    />
                    <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>MCRoyale (unreleased)</h4>
                </div>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>● A Minecraft Battle Royale server developed in Java for versions 1.16 - 1.20.</p>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Last "near-complete" implementation was in 2022. Loot generation, "battle bus" dragon scatter, basic implementation of "Upgrade Stations" and the border systems were implemented and functional.</p>
                <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● My priorities were in game design, features, mechanics, and development.</p>
                <hr></hr>
                <a href="/MCROYALE.pdf" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaFilePdf />Game Design Document</a>
                <p></p>
                <a href="https://www.youtube.com/playlist?list=PLBdGag5aLyoHahEAADpzf4sLrVi1yb_ld" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaYoutube />Playtesting Playlist</a>
            </div>

            <div style={{ padding: '0.75rem', backgroundColor: '#fed7aa', color: '#000', borderRadius: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', transition: 'transform 0.3s' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                    <img
                    src="/applejuice.png"
                    alt="Applejuice Logo"
                    style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '8px',
                        objectFit: 'scale-down',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    />
                    <h4 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>applejuice.bar</h4>
              </div>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>● A Minecraft server specialized in the UHC gamemode developed in Kotlin for version 1.8.</p>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>● Developed several features for the Hosted UHC parts of the server and worked with MongoDB for databases and BungeeCord for the proxy.</p>
              <hr></hr>
              <a href="https://github.com/applejuice-server" target="_blank" rel="noreferrer" style={{ color: '#fb923c', fontSize: '0.95rem' }}><FaGithub />GitHub Organization</a>
            </div>
          </div>
        </motion.section>
      </main>

      <footer style={{ textAlign: 'center', padding: '2rem 0', fontSize: '0.875rem', opacity: 0.7 }}>
        &copy; {new Date().getFullYear()} Marcus M. All rights reserved. i am not good at web design
      </footer>
    </div>
  );
}
